import { createFileRoute } from "@tanstack/react-router";
import { LegalArticle } from "@/components/LegalArticle";
import { useI18n } from "@/lib/i18n";
import { useStorefront } from "@/lib/storefront";
import { legalText } from "@/lib/legal";

export const Route = createFileRoute("/return-policy")({ component: Returns });

function Returns() {
  const { lang, t } = useI18n();
  const storefront = useStorefront();
  return <LegalArticle title={t("footer.returns")} intro={legalText(storefront, "refund", lang)} sections={[]} />;
}
